export const shadow = {
  none: "none",
  sm: "0 1px 2px 0 hsl(220 26% 14% / 0.05)",
  md: "0 4px 12px -2px hsl(220 26% 14% / 0.08), 0 2px 4px -2px hsl(220 26% 14% / 0.04)",
  lg: "0 12px 32px -8px hsl(220 26% 14% / 0.12), 0 4px 8px -4px hsl(220 26% 14% / 0.06)",
} as const;
